import { Injectable, resource, signal } from '@angular/core';
import { Dokument } from '@features/letpensiondk/letpensiondk-dokumenter/dokument.model';
import { RestDatasource } from '@core/api/rest.datasource';
import { DokumenterSearchParams } from '@features/letpensiondk/letpensiondk-dokumenter/dokumenter-search-params.model';

@Injectable({
  providedIn: 'root',
})
export class LpDkDokumenterDatasource extends RestDatasource<Dokument> {
  override endpoint = '/api/admin/lpdkdokumenter';

  searchParams = signal<DokumenterSearchParams>({
    text: '',
    medtagSlettede: false,
  });

  override data = resource({
    params: () => this.searchParams(),
    loader: async ({ params, abortSignal }) => {
      return await this.getList(
        {
          filter: JSON.stringify(params),
          sortBy: 'oprettelsesTidspunkt',
          descending: true,
        },
        abortSignal
      );
    },
  });
}
